var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeertube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 682.68799,
    viewBox: "2799 -911 512 682.688",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2799-911v341.344l256-170.656",
    fill: "#211f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2799-569.656v341.344l256-170.656",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3055-740.344v341.344l256-170.656",
    fill: "#f1680d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeertube);
export default __webpack_public_path__ + "static/media/peertube.69a1b486c0476aaec98d6b4371c26d2b.svg";
export { ForwardRef as ReactComponent };